import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { ThemeProvider } from "@mui/material/styles";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { hiddenOfferTableColum } from "@/config/tableColumnConfig";

// Mui Icon
import { AddOutlined } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

//import generate csv library

// Fetch
import { getAll } from "@/fetch/Pharmagood/fetchHiddenOffer";

// Moment
import { useCurrentAction } from "@/hooks/user";
import "moment/locale/zh-hk";

const HiddenOfferListPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();

  // States
  const [data, setData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    navigate(`${data.id}`);
  };

  const onAddClick = () => {
    navigate("create/");
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const result = await getAll();
      setData(result);
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      selectedIndex={17}
      header="giftsSettingListPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="Hidden Offer"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            {actions?.create && (
              <IconButton component="label" onClick={onAddClick}>
                <AddOutlined />
              </IconButton>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={data}
            onCellClick={(params) => onCellClick(params)}
            columns={hiddenOfferTableColum}
            pageSize={100}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default HiddenOfferListPage;
